import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const skip_error = req.headers.get('skip-error') === 'true';

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!skip_error && !environment.production && error instanceof HttpErrorResponse) {
        console.error(error);
      }
      return throwError(() => error);
    }),
  );
};
